export class EfsReportUrls {

	public static DOWNLOAD_EFS_REPORT = '/api/v1/efsreport/downloadefsreport';

}
